import Phaser from 'phaser';
import { FONT_BODY, GAME_H, GAME_W } from '../config';
import { SceneKeys } from './keys';
import { registerManifest, type LoadGroup } from '@/content/manifest';

export interface LoadingData { group: LoadGroup; onDone: () => void }

/** Small overlay scene that loads one manifest group with a real progress bar, then stops itself. */
export class LoadingScene extends Phaser.Scene {
  private data_!: LoadingData;
  constructor() { super(SceneKeys.LOADING); }
  init(data: LoadingData): void { this.data_ = data; }
  preload(): void {
    this.cameras.main.setBackgroundColor('#05070a');
    const bar = this.add.rectangle(GAME_W / 2, GAME_H / 2, 200, 4, 0x3a2a1e).setOrigin(0.5);
    const fill = this.add.rectangle(GAME_W / 2 - 100, GAME_H / 2, 0, 4, 0xe2c48c).setOrigin(0, 0.5);
    const label = this.add.text(GAME_W / 2, GAME_H / 2 + 14, '装载中… 0%', { fontFamily: FONT_BODY, fontSize: '12px', color: '#c9b89a' }).setOrigin(0.5);
    bar.setDepth(1);
    this.load.on(Phaser.Loader.Events.PROGRESS, (v: number) => { fill.width = Math.round(200 * v); label.setText(`装载中… ${Math.round(v * 100)}%`); });
    this.load.on(Phaser.Loader.Events.FILE_LOAD_ERROR, (file: Phaser.Loader.File) => console.warn(`[load] failed: ${file.key} (${file.url})`));
    registerManifest(this.load, this.data_.group);
  }
  create(): void {
    const done = this.data_.onDone;
    this.scene.stop();
    done();
  }
}
